import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

/**
 * Logic to setup sentry.io monitoring
 */
const sentryMonitoring = () => {
  const host = window.location.hostname;
  const isQATesting = host.includes('app-qatesting');

  // Sentry currently active only on 'app-qatesting.scalyr.com'
  if (!isQATesting) {
    return;
  }

  Sentry.init({
    dsn: 'https://7f9947e2afd845789e34f4bf56db5301@o570797.ingest.sentry.io/5718076',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
};

export default sentryMonitoring;
